import langProjects from '@/apps/projects/lang/';
import urlApis from '@/apps/projects/apis/';
export default {
	langProjects: langProjects,
	urlApis: urlApis,
	access: false,
	asideStorage:[],
	lateralShow: true,
}
